import { Typography } from "./typography";

type Props = {
  summary: string;
};

export function ConversationSummary({ summary }: Props) {
  return (
    <div className="my-4 px-4 py-3 border border-dashed border-border/60 rounded-xl bg-secondary/20">
      <Typography.Label className="text-[11px] mb-1.5 tracking-wider text-text-light">
        Earlier conversation summarized
      </Typography.Label>
      <Typography.Hint className="leading-relaxed">{summary}</Typography.Hint>
    </div>
  );
}
